import React from "react";

export default function EventFacts({ data }) {
  return (
    <div className="template-event-facts-container">
      <div className="template-event-facts">
        <div className="event-coverImage">
          <img src={data?.coverImg} />
        </div>
        {data?.facts && data?.facts !== "<h3></h3>" && (
          <div className="event-content ">
            <div className="event-didYouKnow">did you know?</div>
            <div className="event-facts">
              <div dangerouslySetInnerHTML={{ __html: data?.facts }} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
